import { FieldArray } from "formik"
import { nanoid } from "nanoid"
import CamposPersonalizadoBoardHeader from "./components/BoardHeader"
import CamposPersonalizadoBoardList from "./components/BoardList"

const CamposPersonalizadoBoard = ({
  camposPersonalizados,
  className = "",
  endpointSlice = "",
}: $TSMigrationFixMe) => {
  const handleAddEmptyField = () => ({
    id: nanoid(),
    valor: "",
    clave: "",
    isNew: true,
  })

  return (
    <FieldArray name='camposPersonalizados'>
      {({ remove, push }) => (
        <div className={className}>
          <CamposPersonalizadoBoardHeader
            showTableHeader={!!camposPersonalizados?.length}
            addEmptyLine={() => push(handleAddEmptyField())}
          />
          <CamposPersonalizadoBoardList
            camposPersonalizados={camposPersonalizados}
            addEmptyLine={() => push(handleAddEmptyField())}
            removeItem={remove}
            endpointSlice={endpointSlice}
          />
        </div>
      )}
    </FieldArray>
  )
}

export default CamposPersonalizadoBoard
